import { render } from "./ItemSalesWithModifiersReport.vue?vue&type=template&id=588c15b2&scoped=true"
import script from "./ItemSalesWithModifiersReport.vue?vue&type=script&lang=js"
export * from "./ItemSalesWithModifiersReport.vue?vue&type=script&lang=js"

import "./ItemSalesWithModifiersReport.vue?vue&type=style&index=0&id=588c15b2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588c15b2"]])

export default __exports__